<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmhead">Abbreviations</h2>
<table class="tab">
<tbody><tr>
<td><a id="page_vii">AGOS</a></td>
<td class="tab2">Aviation, Hydro-aviation and Prototype Aircraft Production</td>
</tr>
<tr>
<td>DRP</td>
<td class="tab2">Dynamo-Reactive (Recoilless) Gun</td>
</tr>
<tr>
<td>GUAP</td>
<td class="tab2">Principal Directorate of the Aviation Industry</td>
</tr>
<tr>
<td>GVF</td>
<td class="tab2">Civil Air Fleet</td>
</tr>
<tr>
<td>KhAZOS</td>
<td class="tab2">Kharkov Aviation Plant of Prototype Manufacturing</td>
</tr>
<tr>
<td>NII GVF</td>
<td class="tab2">Scientific Research Institute of Civil Air Fleet</td>
</tr>
<tr>
<td>NII VVS</td>
<td class="tab2">Air Force Scientific Testing Institute</td>
</tr>
<tr>
<td>NKAP</td>
<td class="tab2">People’s Commissariat for the Aviation Industry</td>
</tr>
<tr>
<td>NKTP</td>
<td class="tab2">People’s Commissariat for Heavy Industry</td>
</tr>
<tr>
<td>OGPU</td>
<td class="tab2">United Principal Political Directorate</td>
</tr>
<tr>
<td>OKDVA</td>
<td class="tab2">Special Red-Banner Far East Army</td>
</tr>
<tr>
<td>OKPB</td>
<td class="tab2">Special Design and Manufacturing Bureau</td>
</tr>
<tr>
<td>OTB</td>
<td class="tab2">Special Technical Bureau</td>
</tr>
<tr>
<td>RKKA</td>
<td class="tab2">Worker’s and Peasant’s Red Army;</td>
</tr>
<tr>
<td>RVS</td>
<td class="tab2">Revolutionary Military Council;</td>
</tr>
<tr>
<td>STO</td>
<td class="tab2">Council for Labour and Defence;</td>
</tr>
<tr>
<td>TsAGI</td>
<td class="tab2">Central Aero- and Hydrodynamics Institute.</td>
</tr>
<tr>
<td>UVVS</td>
<td class="tab2">Air Force Directorate;</td>
</tr>
<tr>
<td>VAMM</td>
<td class="tab2">Military Academy of Mechanisation and Motorisation</td>
</tr>
<tr>
<td>VOIZ</td>
<td class="tab2">All Union Society of Inventors</td>
</tr>
<tr>
<td>VVS</td>
<td class="tab2">Air Force</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?80e8f75a